"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tablet_portrait_breakpoint = exports.tablet_landscape_breakpoint = exports.tablet_container_maxwidth = exports.tablet_breakpoint = exports.sm_mobile_breakpoint = exports.sm_laptop_breakpoint = exports.sm_desktop_breakpoint = exports.mobile_width_percentage = exports.md_mobile_breakpoint = exports.md_laptop_breakpoint = exports.lg_mobile_breakpoint = exports.lg_laptop_breakpoint = exports.lg_desktop_breakpoint = exports.desktop_container_maxwidth_compact = exports.desktop_container_maxwidth = exports.desktop_breakpoint_extended = exports.desktop_breakpoint = void 0;
//"design to this size" files in zeplin: zpl.io/aMR9Nqo

//mobile first media query values and container constraints

//327+ is where it goes from mobile to tablet
var tablet_breakpoint = exports.tablet_breakpoint = 327;

//1051+ is where it goes from tablet to desktop
var desktop_breakpoint = exports.desktop_breakpoint = 769;
var desktop_breakpoint_extended = exports.desktop_breakpoint_extended = 1024;

// the purpose of these values is to constrain the main container
var tablet_container_maxwidth = exports.tablet_container_maxwidth = 512;
var desktop_container_maxwidth = exports.desktop_container_maxwidth = 1400;
var desktop_container_maxwidth_compact = exports.desktop_container_maxwidth_compact = 1100;
var mobile_width_percentage = exports.mobile_width_percentage = 86;

/* Adding 2021 Standard Breakpoints
Mobile */
var sm_mobile_breakpoint = exports.sm_mobile_breakpoint = 320;
var md_mobile_breakpoint = exports.md_mobile_breakpoint = 375;
var lg_mobile_breakpoint = exports.lg_mobile_breakpoint = 425;

/*Tablet */
var tablet_portrait_breakpoint = exports.tablet_portrait_breakpoint = 768;
var tablet_landscape_breakpoint = exports.tablet_landscape_breakpoint = desktop_breakpoint_extended;

/*Laptop */
var sm_laptop_breakpoint = exports.sm_laptop_breakpoint = 1200;
var md_laptop_breakpoint = exports.md_laptop_breakpoint = 1366;
var lg_laptop_breakpoint = exports.lg_laptop_breakpoint = 1440;

/*Desktop */
var sm_desktop_breakpoint = exports.sm_desktop_breakpoint = 1680;
var lg_desktop_breakpoint = exports.lg_desktop_breakpoint = 1920;